import { Payments } from '../../utils';
import QantasPointsLineItem from './components/QantasPointsLineItem';
import CashLineItem from './components/CashLineItem';
import CreditVoucherLineItem from './components/CreditVoucherLineItem';
import { SelfServiceAPI } from 'types';
import QantasTravelPassLineItem from './components/QantasTravelPassLineItem';

export interface PaidLineItemsProps {
  transactionAmounts: Payments;
}

const PaidLineItems = ({ transactionAmounts }: PaidLineItemsProps) => (
  <>
    {transactionAmounts.map((transaction, index) => {
      switch (transaction.method) {
        case 'points':
          return (
            <QantasPointsLineItem
              key={`paid-line-item-${index}`}
              type={transaction.type}
              createdAt={transaction.createdAt}
              qffNumber={(transaction as SelfServiceAPI.PointsPaymentMethod).qffNumber}
              total={transaction.total}
            />
          );
        case 'credit_card':
          return (
            <CashLineItem
              key={`paid-line-item-${index}`}
              type={transaction.type}
              createdAt={transaction.createdAt}
              cardType={(transaction as SelfServiceAPI.CreditCardPaymentMethod).cardType}
              cardNumber={(transaction as SelfServiceAPI.CreditCardPaymentMethod).lastFourDigits}
              total={transaction.total}
            />
          );
        case 'credit_note':
          return (
            <CreditVoucherLineItem
              key={`paid-line-item-${index}`}
              type={transaction.type}
              createdAt={transaction.createdAt}
              voucherCode={(transaction as Pick<SelfServiceAPI.CreditNotePaymentMethod, 'lastFourCharacters'>).lastFourCharacters}
              total={transaction.total}
            />
          );
        case 'qantas_group_credit_voucher':
          return (
            <QantasTravelPassLineItem
              key={`paid-line-item-${index}`}
              type={transaction.type}
              createdAt={transaction.createdAt}
              cardNumber={(transaction as unknown as SelfServiceAPI.QantasGroupCreditVoucherPaymentMethod).cardNumber}
              total={transaction.total}
            />
          );
        default:
          return null;
      }
    })}
  </>
);

export default PaidLineItems;
